import { jsx } from "react/jsx-runtime";
import StarHalfIcon from "@mui/icons-material/StarHalf";
import { validateTidalLicense } from "../../base/index.js";
function StarHalf(props) {
  return /* @__PURE__ */ jsx(
    StarHalfIcon,
    {
      "data-testid": "StarHalf",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "StarHalf",
      "data-tidal-icon-meta": "ratings,sentiments"
    }
  );
}
StarHalf.tidalIconMeta = {
  categories: "ratings,sentiments",
  name: "StarHalf"
};
validateTidalLicense();
export {
  StarHalf
};
//# sourceMappingURL=StarHalf.js.map
